// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"4d831d40","241":"dcdef423","262":"ad9f189b","491":"86d7121a","686":"698d71da","736":"5911bb8e","942":"3f4aab52","946":"c87b2356"}[chunkId] + ".chunk.js";
};